import { pgEnum, pgTable, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core";
export const userStatus = {
    ACTIVE: "active",
    OFFLINE: "offline",
};
function enumToPgEnum(myEnum) {
    return Object.values(myEnum);
}
export const userStatusEnum = pgEnum("user_status", enumToPgEnum(userStatus));
// Table name is 'users' (plural) to avoid PostgreSQL reserved keyword 'user'
export const users = pgTable("users", {
    // User ID from Keycloak (UUID format)
    id: uuid("id").primaryKey(),
    createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .defaultNow()
        .notNull()
        .$onUpdate(() => new Date()),
    firstName: varchar("first_name", { length: 100 }).notNull(),
    lastName: varchar("last_name", { length: 100 }).notNull(),
    email: varchar("email", { length: 100 }).unique().notNull(),
    personioUserId: uuid("personio_user_id"),
    callOneUserId: uuid("call_one_user_id"),
    skillLevel: varchar("skill_level", { length: 100 }).notNull(),
    status: userStatusEnum("status").notNull().default(userStatus.ACTIVE),
    // Keycloak roles (realm + client roles, synced via webhook)
    roles: text("roles").array().default([]).notNull(),
    // Keycloak groups (organizational structure, synced via webhook)
    groups: text("groups").array().default([]).notNull(),
});
